<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogClient"
    :before-close="doClose"
    width="90%"
    top="5%"
    class="abow_dialog"
  >
    <el-form
      ref="KTarget"
      :model="KTarget"
      label-width="175px"
      class="queryform_div"
    >
      <el-row :gutter="24">
        <el-col :md="10" :sm="24">
          <el-form-item :label="$t('desc.airCompressorSN')">
            <el-select
              v-model="KTarget.value1"
              multiple
              filterable
               collapse-tags
              :placeholder="$t('desc.select')" 
              size="small"
              style="width:100%;"
            >
              <el-option value="全部" :label="$t('desc.all')"></el-option>
              <el-option
                v-for="item in deviceOption"
                :key="item.id"
                :label="item.dsn"
                :value="item.gsn"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
          <el-col :md="14" :sm="24">
          <el-form-item :label="projectType=='Web'?$t('web.MonitoringDate'):$t('title.MonitoringDate')">
            <el-date-picker
              v-model="KTarget.date"
              type="date"
              :placeholder="$t('title.chooseDate')"
              size="small"
              style="width:33.3333%"
            >
            </el-date-picker>
            <template>
              <el-time-select
              size="small"
              style="width:33.3333%"
                :placeholder="$t('title.beginDate')"
                v-model="KTarget.startTime"
                :picker-options="{
                  start: '08:30',
                  step: '00:15',
                  end: '18:30'
                }">
              </el-time-select>
              <el-time-select
              size="small"
              style="width:33.3333%"
              :placeholder="$t('title.endDate')"
                v-model="KTarget.endTime"
                :picker-options="{
                  start: '08:30',
                  step: '00:15',
                  end: '18:30',
                  minTime: KTarget.startTime
                }">
              </el-time-select>
            </template>
          </el-form-item>
          <!-- <el-form-item label="监控日期">
            <el-date-picker
              v-model="KTarget.time"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="2020-11-26"
              end-placeholder="2020-11-19"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item> -->
        </el-col>
        <el-col :md="24" :sm="24">
          <el-form-item :label="projectType=='Web'?$t('web.MonitoringParameters'):$t('title.MonitoringParameters')">
            <el-select
              v-model="KTarget.value2"
              multiple
              :multiple-limit="5"
              filterable
              :placeholder="$t('title.selectFive')"
              style="width: 100%"
              size="small"
            >
              <el-option
                v-for="item in gatherOption"
                :key="item.id"
                :label="activeLang=='zh'?item.nameZH:item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :md="24" :sm="24" style="margin-top: 6px">
          <el-button type="primary" @click="showEcharts" size="small">{{projectType=='Web'?$t("web.viewMonitor"):$t("title.viewMonitor")}}</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-row :gutter="24" v-if="showEDiv">
      <!--这部分动态加载-->
      <el-col
        :md="12"
        :sm="24"
        v-for="(item, index) in monitorDataList"
        :key="item.gsn"
      >
        <div class="echarts_Monitoring">
          <h4>
            {{$t("desc.airCompressorSN")}}：<strong>{{item.dsn}}</strong>
          </h4>
          <div
            class="echarts"
            :id="getEchartId(index)"
            style="height: 320px"
          ></div>
        </div>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import { getDevicesByCustomer, getDevicesByCustomerList} from "../../../api/api"
export default {
  name: "index",
  props: {
    activeLang:"",
    projectType:"",
    dialogClient: false,
    title: "",
    gatherOption: {
      type: Array,
      default: function () {
        return [];
      },
    },
    monitorDataList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    customer: {},
  },
  watch: {
    dialogClient: {
      async handler(newValue, oldValue) {
        if (newValue === true){
          await this.getOption();
          await this.showEcharts("first");
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      showEDiv: false,
      KTarget: {
        value1:["全部"],
        date:new Date()
      },
      monitorDataListData:[],
      deviceOption:[],
    };
  },
  methods: {
    onSubBtn(value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          this.$emit("onSubBtn", true);
        } else {
          return false;
        }
      });
    },
    onSearchBtn() {
      
      this.$emit("onSearchBtn", this.KTarget);
    },
    doClose() {
      this.$emit("dialogVisibleEvent", false);
      this.KTarget = {
        value1: new Array(),
        date:new Date()
      };
      //   this.$refs.gsnForm.resetFields();
    },
    resetKeyword() {
      this.snSelect = {};
    },
    getEchartId(index) {
      return "Kchart_" + index;
    },
    // getDsntId(index) {
    //   return "Dsn_" + index;
    // },
    async getOption(){
      
      let resDeviceList =new Array();
      if(this.projectType == "Web"){
        resDeviceList = await getDevicesByCustomerList();
      }else{
        let custArr = new Array();
        custArr.push(this.customer.id);
        let data = {
          idList: custArr,
          Language: this.activeLang,
        };
        resDeviceList = await getDevicesByCustomer(data);
      }
      let curDeviceList = resDeviceList.result.filter((item) => item.gsn);
      if(this.customer){
        this.deviceOption = curDeviceList.filter(
          (device) => device.customerId == this.customer.id && device.gatewayId
        );
      }else{
        this.deviceOption = curDeviceList;
      }
    },
    showEcharts(type) {
      if(type == "first"){
        let arr=["Compressor Discharge Temperature","Final Stage Discharge Temperature","Compressor Discharge Pressure","System Pressure"];
        this.$set(this.KTarget,"value2",arr);
      }
      
      var that = this;
      this.showEDiv = true;
      if (!this.KTarget.value2 || this.KTarget.value2.length == 0) {
        that.$message({
          showClose: true,
          message: that.projectType=='Web'?this.$t("web.selectMonitoringParameters"):this.$t("tips.selectMonitoringParameters"),

          type: "error",
        });
        return false;
      }
      if (!this.KTarget.date) {
        that.$message({
          showClose: true,
          message: this.$t("tips.selectDate"),
          type: "error",
        });
        return false;
      }
      var startDate="";
      var endDate="";
      if (!this.KTarget.startTime) {
        startDate="00:00"
      }else{
        startDate=this.KTarget.startTime
      }
      if (!this.KTarget.endTime) {
        endDate="23:59"
      }else{
        endDate=this.KTarget.endTime;
      }
      var gsnList = new Array();
      if (
        !this.KTarget.value1 ||
        this.KTarget.value1.length == 0 ||
        this.KTarget.value1.indexOf("全部") != -1
      ) {
        for (let index = 0; index < this.deviceOption.length; index++) {
          gsnList.push(this.deviceOption[index].gsn);
        }
      } else {
        gsnList = this.KTarget.value1;
      }
      this.$emit("showEcharts", this.KTarget, gsnList,startDate,endDate,"monitor",this.deviceOption);
      // setTimeout(function () {
      //   self.initEcharts();
      // }, 100);
    },
  },
};
</script>

<style>
</style>
